import { CommonModule } from '@angular/common';  
import { NgModule } from '@angular/core';
import { ComponentsModule } from '../../components/components.module';
import { ConditionsComponent } from './conditions.component';
import { AngularFontAwesomeModule } from 'angular-font-awesome';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import { CategoryModule } from './category/category.module';
import { CompensationModule } from './compensation/compensation.module';
import { PlanModule } from './plan/plan.module';

@NgModule({
    declarations:[
        ConditionsComponent
    ],
    imports:[
        CommonModule,
        ComponentsModule,
        CategoryModule,
        CompensationModule,
        PlanModule,
        AngularFontAwesomeModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        })
    ],
    exports:[
        ConditionsComponent
    ]
})
export class ConditionsModule {}

  // required for AOT compilation
export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http);
  }